// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"7fb7b2b5","824":"34896b97"}[chunkId] + ".chunk.css";
};